import { post } from './httpClient'

export const login = (body) => post('/authorization/login/employee', body)
export const resetPassword = (body) => post('/authorization/reset-password', body)
